import { Argument } from 'classnames';

export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
}

export interface RenderOptions {
  className?: Argument;
  thumbnail?: boolean;
  autoplay?: boolean;
  muted?: boolean;
  controls?: boolean;
  hideFilename?: boolean;
  onPreview?: () => void;
  onPageChange?: (pageNumber: number, totalPages: number) => void;
  watermarkTitle?: string;
  onSeeking?: () => void;
  disableAutoPause?: boolean;
}

interface Metadata {
  description?: string;
}

export interface AbstractMedia {
  id?: string;
  path: string;
  type: MediaType;
  uploadId?: string;
  filename?: string;
  metadata?: Metadata;
  restricted?: boolean;
  contentType?: string;
  originalPath?: string;
  thumbnailPath?: string;
  mediaMetricUrl?: string;
  time?: number;
}
